<template>
  <div class="colored-icon">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 615 759"
      :class="fileColor + '-file-icon'"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      xml:space="preserve"
      xmlns:serif="http://www.serif.com/"
      style="
        fill-rule: evenodd;
        clip-rule: evenodd;
        stroke-linejoin: round;
        stroke-miterlimit: 2;
      "
    >
      <g transform="matrix(0.75,0,0,0.75,-49023.3,-2330.93)">
        <g transform="matrix(5.55556,0,0,5.55556,51105.4,0)">
          <g transform="matrix(1,0,0,1,2707.12,647.91)">
            <path
              d="M0,-47.654L-13.209,35.889L-109.389,37.839L-109.389,-81.827L-35.206,-85.493L0,-47.654Z"
              class="white-fill-part"
              style="fill-rule: nonzero"
            />
          </g>
        </g>
        <g transform="matrix(5.55556,0,0,5.55556,51105.4,0)">
          <g transform="matrix(1,0,0,1,2637.18,630.95)">
            <path
              d="M0,16.742C5.291,14.945 10.294,13.246 15.24,11.567C12.184,7.692 9.16,3.857 6.12,0C4.083,5.572 2.073,11.071 0,16.742"
              class="colored-file"
              style="fill-rule: nonzero"
            />
          </g>
        </g>
        <g transform="matrix(5.55556,0,0,5.55556,51105.4,0)">
          <g transform="matrix(1,0,0,1,2642.69,599.275)">
            <path
              d="M0,16.08C0.897,12.251 1.952,8.45 2.64,4.583C3.131,1.818 1.389,-0.118 -1.033,-0.05C-3.366,0.016 -5.083,1.97 -4.478,4.555C-3.558,8.49 -2.2,12.323 -1.028,16.198C-0.686,16.159 -0.343,16.12 0,16.08"
              class="colored-file"
              style="fill-rule: nonzero"
            />
          </g>
        </g>
        <g transform="matrix(5.55556,0,0,5.55556,51105.4,0)">
          <g transform="matrix(1,0,0,1,2679.14,649.239)">
            <path
              d="M0,-6.973C-4.702,-6.396 -9.359,-5.461 -14.035,-4.673C-14.028,-4.42 -14.021,-4.168 -14.014,-3.915C-9.581,-1.638 -4.979,0.156 0.118,0.238C2.252,0.272 3.732,-1.33 3.761,-3.336C3.792,-5.428 2.22,-7.245 0,-6.973"
              class="colored-file"
              style="fill-rule: nonzero"
            />
          </g>
        </g>
        <g transform="matrix(5.55556,0,0,5.55556,51105.4,0)">
          <g transform="matrix(1,0,0,1,2613.58,665.389)">
            <path
              d="M0,-1.599C-1.022,-0.996 -1.905,0.898 -1.777,2.085C-1.661,3.162 -0.192,4.718 0.878,4.901C2.063,5.102 3.955,4.348 4.693,3.371C6.961,0.371 8.825,-2.934 10.846,-6.12C10.667,-6.314 10.489,-6.507 10.311,-6.701C6.854,-5.035 3.293,-3.543 0,-1.599"
              class="colored-file"
              style="fill-rule: nonzero"
            />
          </g>
        </g>
        <g transform="matrix(5.55556,0,0,5.55556,51105.4,0)">
          <g transform="matrix(1,0,0,1,2683.35,672.378)">
            <path
              d="M0,-68.872C-7.174,-68.872 -12.793,-74.291 -12.793,-81.209L-12.793,-106.295L-10.952,-106.295C-8.669,-106.295 -6.487,-105.36 -4.913,-103.707L20.743,-75.751C22.466,-73.874 23.421,-71.42 23.421,-68.872L0,-68.872ZM-4.033,-17.416C-11.408,-17.434 -18.047,-19.956 -24.061,-24.111C-25.366,-25.012 -26.482,-25.382 -28.033,-24.836C-35.123,-22.339 -42.258,-19.966 -49.338,-17.44C-50.149,-17.151 -50.898,-16.294 -51.371,-15.515C-54.249,-10.773 -56.992,-5.947 -59.875,-1.208C-61.941,2.188 -64.993,4.045 -69.038,3.581C-73.153,3.108 -75.754,0.643 -77.018,-3.27C-77.064,-3.411 -77.174,-3.53 -77.253,-3.66L-77.253,-7.775C-75.754,-11.766 -72.57,-13.983 -68.866,-15.563C-64.467,-17.441 -59.987,-19.129 -55.608,-21.05C-54.61,-21.488 -53.476,-22.383 -53.094,-23.342C-49.98,-31.169 -46.988,-39.045 -44.089,-46.954C-43.781,-47.795 -44.145,-49.005 -44.483,-49.94C-46.384,-55.21 -48.857,-60.327 -50.208,-65.727C-51.92,-72.572 -49.846,-75.836 -43.416,-78.651L-39.758,-78.651C-33.356,-75.841 -31.483,-72.713 -32.896,-65.695C-33.912,-60.65 -35.57,-55.728 -37.071,-50.791C-37.502,-49.371 -37.644,-48.173 -36.696,-46.951C-33.02,-42.217 -29.356,-37.474 -25.702,-32.722C-24.887,-31.662 -24.007,-31.674 -22.739,-31.989C-17.584,-33.271 -12.42,-34.593 -7.188,-35.469C-1.33,-36.45 2.94,-34.082 4.53,-29.534C6.587,-23.65 2.275,-17.401 -4.033,-17.416M27.636,-76.38C20.081,-83.146 0.476,-106.519 -4.246,-110.91C-5.737,-112.296 -7.758,-112.955 -9.793,-112.955L-85.984,-112.955C-92.786,-112.955 -98.3,-107.441 -98.3,-100.639L-98.3,31.767C-98.3,38.569 -92.786,44.083 -85.984,44.083L18.537,44.083C25.339,44.083 30.854,38.569 30.854,31.767L30.854,-69.655C30.854,-72.268 29.583,-74.637 27.636,-76.38"
              class="colored-file"
              style="fill-rule: nonzero"
            />
          </g>
        </g>
        <g transform="matrix(5.55556,0,0,5.55556,51105.4,0)">
          <g transform="matrix(1,0,0,1,2658.12,691.519)">
            <path
              d="M0,49.885L-84.525,49.885C-88.378,49.885 -91.502,46.761 -91.502,42.908L-91.502,6.978C-91.502,3.124 -88.378,0 -84.525,0L0,0C3.854,0 6.977,3.124 6.977,6.978L6.977,42.908C6.977,46.761 3.854,49.885 0,49.885"
              style="fill: rgb(239, 69, 99); fill-rule: nonzero"
            />
          </g>
        </g>
        <g transform="matrix(5.55556,0,0,5.55556,51105.4,0)">
          <g transform="matrix(1,0,0,1,2600.73,718.959)">
            <path
              d="M0,-3.514C0.537,-4.023 0.807,-4.691 0.807,-5.517C0.807,-6.362 0.537,-7.043 0,-7.562C-0.538,-8.08 -1.249,-8.34 -2.133,-8.34L-5.791,-8.34C-5.888,-8.34 -5.936,-8.292 -5.936,-8.197L-5.936,-2.895C-5.936,-2.798 -5.888,-2.751 -5.791,-2.751L-2.133,-2.751C-1.249,-2.751 -0.538,-3.005 0,-3.514M1.814,-11.077C2.774,-10.559 3.519,-9.824 4.048,-8.873C4.575,-7.922 4.84,-6.832 4.84,-5.603C4.84,-4.393 4.566,-3.327 4.019,-2.405C3.472,-1.483 2.703,-0.767 1.714,-0.259C0.725,0.251 -0.414,0.505 -1.7,0.505L-5.791,0.505C-5.888,0.505 -5.936,0.553 -5.936,0.649L-5.936,7.996C-5.936,8.092 -5.97,8.174 -6.036,8.241C-6.104,8.308 -6.186,8.341 -6.281,8.341L-9.652,8.341C-9.748,8.341 -9.83,8.308 -9.897,8.241C-9.965,8.174 -9.998,8.092 -9.998,7.996L-9.998,-11.509C-9.998,-11.605 -9.965,-11.687 -9.897,-11.754C-9.83,-11.822 -9.748,-11.855 -9.652,-11.855L-1.527,-11.855C-0.26,-11.855 0.854,-11.596 1.814,-11.077"
              class="white-fill-part"
              style="fill-rule: nonzero"
            />
          </g>
        </g>
        <g transform="matrix(5.55556,0,0,5.55556,51105.4,0)">
          <g transform="matrix(1,0,0,1,2613.98,710.618)">
            <path
              d="M0,13.196L3.486,13.196C4.369,13.196 5.085,12.898 5.633,12.303C6.18,11.708 6.463,10.911 6.482,9.912L6.482,3.285C6.482,2.287 6.209,1.489 5.661,0.894C5.114,0.299 4.379,0.001 3.457,0.001L0,0.001C-0.097,0.001 -0.144,0.049 -0.144,0.144L-0.144,13.052C-0.144,13.148 -0.097,13.196 0,13.196M-4.105,16.582C-4.173,16.514 -4.206,16.433 -4.206,16.337L-4.206,-3.14C-4.206,-3.236 -4.173,-3.317 -4.105,-3.385C-4.038,-3.451 -3.957,-3.486 -3.86,-3.486L3.342,-3.486C4.782,-3.486 6.046,-3.231 7.131,-2.722C8.216,-2.213 9.057,-1.497 9.651,-0.575C10.247,0.346 10.545,1.413 10.545,2.623L10.545,10.574C10.545,11.785 10.247,12.85 9.651,13.772C9.057,14.694 8.216,15.41 7.131,15.919C6.046,16.428 4.782,16.682 3.342,16.682L-3.86,16.682C-3.957,16.682 -4.038,16.649 -4.105,16.582"
              class="white-fill-part"
              style="fill-rule: nonzero"
            />
          </g>
        </g>
        <g transform="matrix(5.55556,0,0,5.55556,51105.4,0)">
          <g transform="matrix(1,0,0,1,2643.15,723.915)">
            <path
              d="M0,-13.396C-0.067,-13.329 -0.148,-13.295 -0.245,-13.295L-9.666,-13.295C-9.763,-13.295 -9.81,-13.248 -9.81,-13.152L-9.81,-8.686C-9.81,-8.589 -9.763,-8.542 -9.666,-8.542L-3.472,-8.542C-3.376,-8.542 -3.294,-8.508 -3.227,-8.441C-3.159,-8.374 -3.126,-8.292 -3.126,-8.196L-3.126,-5.401C-3.126,-5.305 -3.159,-5.223 -3.227,-5.157C-3.294,-5.088 -3.376,-5.055 -3.472,-5.055L-9.666,-5.055C-9.763,-5.055 -9.81,-5.007 -9.81,-4.912L-9.81,3.041C-9.81,3.137 -9.844,3.218 -9.911,3.286C-9.979,3.353 -10.06,3.386 -10.156,3.386L-13.526,3.386C-13.623,3.386 -13.704,3.353 -13.771,3.286C-13.839,3.218 -13.872,3.137 -13.872,3.041L-13.872,-16.436C-13.872,-16.532 -13.839,-16.613 -13.771,-16.681C-13.704,-16.748 -13.623,-16.782 -13.526,-16.782L-0.245,-16.782C-0.148,-16.782 -0.067,-16.748 0,-16.681C0.067,-16.613 0.101,-16.532 0.101,-16.436L0.101,-13.641C0.101,-13.544 0.067,-13.463 0,-13.396"
              class="white-fill-part"
              style="fill-rule: nonzero"
            />
          </g>
        </g>
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  props: {
    file_id: String,
  },
  watch: {
    "$store.state.all_files_tags"(new_val, old_val) {
      console.log(
        "Changes in store",
        this.$store.state.all_files_tags,
        new_val
      );
    },
  },
  computed: {
    fileColor() {
      let idx_found = this.$store.state.all_files_tags.findIndex(
        (p) => p.file_id == this.file_id
      );
      if (idx_found < 0) {
        return "gray";
      } else {
        console.log(
          "Icon color for file",
          this.$store.state.all_files_tags[idx_found].tag
        );
        return this.findTagById(this.$store.state.all_files_tags[idx_found].tag)
          .color;
      }
    },
  },
  methods: {
    findTagById(tag_id) {
      return this.$store.state.availableFileTags.filter(
        (p) => p.id == tag_id
      )[0];
    },
  },
};
</script>

<style></style>
